import type { ReactiveControllerHost } from 'lit';
import { CustomError } from '../../../../_ui-core_/base/package/patterns/package/CError';
import App from '../../../../app';
import BaseController, { type EventAction, type IGameController } from '../base-controller';

type yggdrasilEvent = {
  event: string;
  data: unknown;
};
export default class YggdrasilGameController extends BaseController implements IGameController {
  constructor(host: ReactiveControllerHost) {
    super(host, 'ygg');
  }

  public async getLaunchUrl(forReal: boolean, gameId: string): Promise<string> {
    try {
      const info = await App.instance.casino.getGameLaunchInfo(this.provider, gameId, forReal);

      if (!info.launchConfig.launchUrl) {
        return Promise.reject(new CustomError('Launch URL is missing.', { code: 404 }));
      }

      return info.launchConfig.launchUrl;
    } catch (error: any) {
      return Promise.reject(
        new CustomError(`Failed to get game launch info: ${error.message}`, {
          code: error.code || 500,
          type: error.type,
        }),
      );
    }
  }

  public getLaunchUrlIOs(forReal: boolean, gameId: string, gameBaseUrl: string): Promise<string> {
    window.$app.logger.warn('TODO - NATIVE GAME LAUNCH NOT IMPLEMENTED!', gameBaseUrl);
    return this.getLaunchUrl(forReal, gameId); // TODO
  }

  public handleMessageEvent(data: string | yggdrasilEvent): EventAction | null {
    window.$app.logger.log('message', data);

    const type = (data as yggdrasilEvent).event ?? data;

    const markActivityEvents = [
      'audio/volume',
      'bet/changed',
      'current/balance',
      'deposit/show',
      'game/sessionClosed',
      'gameRound/end',
      'spin/end',
      'spin/lowBalance',
      'spin/start',
      'willClosingGameLeaveUnfinishedResponse',
    ];

    if (markActivityEvents.includes(type)) {
      return this.markActivity();
    }

    switch (type) {
      case 'gameRound/start':
        return this.markActivityAndSpinSuccess();
      case 'home/press':
        return this.closeGame();
      case 'spin/error':
      case 'request/error':
      case 'errorOccured':
        window.$app.logger.log('message', data);
    }

    return null;
  }

  public handleAdditionalEventListeners(iframeUrl: string, iframeEl: HTMLIFrameElement) {
    const url = new URL(iframeUrl);

    // To listen for specific events, we need to post corresponding ones first. These events work in a request/response manner
    // E.G. "audio/mute" or "audio/unmute" message will trigger an "audio/volume" emitted event
    const events = [
      'audio/mute',
      'audio/unmute',
      'autospin/stop',
      'balance/update',
      'bet/setMinBet',
      'errorHandled',
      'errorHandledByOperator',
      'game/close',
      'game/pause',
      'game/resume',
      'game/sessionClose',
      'gameRules/open',
      'get/audio/volume',
      'get/balance',
      'intro/skip',
      'launchGame',
      'propertiesUpdated',
      'realityCheck/resume',
      'resize',
      'restore/skip',
      'spin/init',
      'splashScreen/skip',
      'willClosingGameLeaveUnfinishedGame',
    ];

    for (const eventType of events) {
      iframeEl.contentWindow?.postMessage(
        {
          messageType: 'addEventListener',
          eventType: eventType,
        },
        url.origin,
      );
    }
  }
}
